module.exports = __webpack_public_path__ + "static/media/Fonaton.88ac6031.svg";